import { render } from "./view_pricing.vue?vue&type=template&id=be962018&scoped=true"
import script from "./view_pricing.vue?vue&type=script&lang=js"
export * from "./view_pricing.vue?vue&type=script&lang=js"

import "./view_pricing.vue?vue&type=style&index=0&id=be962018&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be962018"]])

export default __exports__